import React, { useMemo, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';

import { ICohortVessel } from '../../cohortTypes';
import { ColDef, themeBalham } from 'ag-grid-enterprise';
import ImoAndNameCellRenderer from '../../../../../shared/components/renderers/customCellRenderers/ImoAndNameCellRenderer';
import OwnerCellRenderer from '../../../../../shared/components/renderers/customCellRenderers/OwnerCellRenderer';

export interface ICohortFleetListProps {
	cohortVessels: ICohortVessel[] | [];
	// onFilteredDataChange?: (filteredData: ICohortVessel[]) => void;
}

const CohortFleetList: React.FC<ICohortFleetListProps> = ({ ...props }) => {
	const gridRef = useRef<AgGridReact>(null);

	// const onFilterChanged = useCallback(
	// 	(_event: FilterChangedEvent) => {
	// 		if (onFilteredDataChange && gridRef.current) {
	// 			const filteredData: ICohortVessel[] = [];
	// 			gridRef.current.api.forEachNodeAfterFilter((node) => {
	// 				if (node.data) {
	// 					filteredData.push(node.data);
	// 				}
	// 			});

	// 			onFilteredDataChange(filteredData);
	// 		}
	// 	},
	// 	[onFilteredDataChange],
	// );

	const columnDefs = useMemo<ColDef[]>(
		() => [
			{
				headerName: 'Vessel Name',
				field: 'name',
				floatingFilter: true,
				headerTooltip: 'Vessel Name',
				cellRenderer: ImoAndNameCellRenderer,
				cellRendererParams: {
					// This is where you can pass additional parameters to the cell renderer if needed
					imoNumber: (params: any) => params.data.imoNumber,
				},
			},

			// { headerName: 'IMO Number', field: 'imoNumber' },
			{
				headerName: 'IMO Number',
				field: 'imoNumber',
				floatingFilter: true,
				headerTooltip: 'IMO Number',
				cellRenderer: ImoAndNameCellRenderer,
				cellRendererParams: {
					// This is where you can pass additional parameters to the cell renderer if needed
					imoNumber: (params: any) => params.data.imoNumber,
				},
			},
			{
				headerName: 'MSI Controlling Entity',
				field: 'msiControllingEntity',
				floatingFilter: true,
				cellRenderer: OwnerCellRenderer,
			},
			{ headerName: 'Size', field: 'size', floatingFilter: true, filter: 'agNumberColumnFilter' },
			{ headerName: 'Size Units', field: 'sizeUnit', floatingFilter: true, filter: 'agSetColumnFilter' },
			{ headerName: 'Year Of Delivery', field: 'yearOfDelivery', floatingFilter: true, filter: 'agNumberColumnFilter' },
			{ headerName: 'Gear', field: 'gear', floatingFilter: true, filter: 'agSetColumnFilter' },
			{ headerName: 'Scrubber Fitted', field: 'scrubberFitted', floatingFilter: true, filter: 'agSetColumnFilter' },
			{ headerName: 'Fuel System', field: 'fuelSystem', floatingFilter: true, filter: 'agSetColumnFilter' },
		],
		[],
	);

	const rowData = props.cohortVessels;

	const defaultColDef = useMemo<ColDef>(() => {
		return {
			flex: 1,
			filter: 'agTextColumnFilter',
		};
	}, []);

	return (
		<AgGridReact
			ref={gridRef}
			columnDefs={columnDefs}
			rowData={rowData}
			defaultColDef={defaultColDef}
			theme={themeBalham}
			// onFilterChanged={onFilterChanged}
		/>
	);
};

export default CohortFleetList;
